<template>
  <Typography :align="'start'" vertical-align="center" tag="th" style="cursor: pointer">
    <span class="d-flex align-center gap-2">
      {{ title }}
      <v-icon v-if="(columnSortKey || title) === sortKey">mdi-arrow-{{ asc ? "up" : "down" }}</v-icon>
    </span>
  </Typography>
</template>

<script setup lang="ts">
import Typography from "../typography.vue";
defineProps<{
  title: string;
  sortKey: string;
  asc: boolean;
  columnSortKey?: string;
}>();

//
</script>

<style scoped lang="scss">
@use "@/assets/_vars.scss" as *;
@use "@/assets/_breakpoints.scss" as breakpoints;
</style>
